import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { PanelChevronComponent } from '../../../UI-Lib/Weissman-Panel/panel.chevron.component';
import { ValuationModule } from '../../../Valuation/valuation.module';
import { AceLoaderComponent } from '../../../UI-Lib/ACE/Loader/loader.component';

@Component({
    selector: 'valuation-panel',
    templateUrl: './valuationPanel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AceLoaderComponent, PanelChevronComponent, TabsModule, ValuationModule],
})
export class ValuationPanelComponent {
    @Input() companyId: number;
    @Input() parcelId: number;
    @Input() siteId: number;
    @Input() company: Core.CompanyModel;

    onIncomeStatementLoading: boolean = true;
    onRentRollLoading: boolean = true;
    hasViewPermission: boolean = true;
    showBody: boolean = false;
    showIncomeStatement: boolean = true;
    showRentRoll: boolean = false;

    expandOrCollapse(): void {
        this.showBody = !this.showBody;
    }

    incomeStatementSelected() {
        this.showRentRoll = false;
        this.showIncomeStatement = true;
    }

    rentRollSelected() {
        this.showIncomeStatement = false;
        this.showRentRoll = true;
    }
}
